// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"54db23dd","335":"050536a9","506":"13c94541","551":"890c6a2a","691":"f03cdba9","765":"151afc9a","852":"f58fcf2a","880":"308f4d11"}[chunkId] + ".chunk.js";
};